import "./App.css";
import { Provider } from "react-redux";
import store from "./store/index.js";
import { PersistGate } from "redux-persist/integration/react";
import persistStore from "redux-persist/es/persistStore.js";
import Body from "./components/Body";
import '@fortawesome/fontawesome-free/css/all.min.css';
const persistor = persistStore(store);

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <div className="App">
          <Body />
        </div>
      </PersistGate>
    </Provider>
  );
}

export default App;
